export default "__VITE_ASSET__CePanKFz__"